import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Linkedin, Twitter } from "lucide-react";
import { NAV_LINKS, CONTACT_INFO } from "../../data/mockData";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8 border-t-4 border-primary">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block bg-white rounded-md p-3 shadow-lg">
               <img 
                src="https://customer-assets.emergentagent.com/job_6a9ec03d-39e5-4689-929c-7a68b7c62383/artifacts/7bwa7zl1_Yantraksh_Logo.png" 
                alt="Yantraksh Projects" 
                className="h-24 w-auto object-contain"
              />
            </Link>
            <p className="text-white font-display font-bold uppercase tracking-wider text-lg">Yantraksh Projects Pvt. Ltd.</p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Integrated Industrial Solutions for Mining, Metals & Heavy Industry. 
              Predict. Prevent. Perform.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="p-2 bg-slate-800 hover:bg-primary transition-colors rounded-sm"><Linkedin size={18} /></a>
              <a href="#" className="p-2 bg-slate-800 hover:bg-primary transition-colors rounded-sm"><Twitter size={18} /></a>
              <a href="#" className="p-2 bg-slate-800 hover:bg-primary transition-colors rounded-sm"><Facebook size={18} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-bold text-lg mb-6 uppercase tracking-wider text-primary">Quick Links</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors text-sm uppercase tracking-wide flex items-center gap-2">
                    <span className="h-1 w-1 bg-primary rounded-full"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-bold text-lg mb-6 uppercase tracking-wider text-gold">Explore</h4>
            <ul className="space-y-3">
              {[
                { name: "Case Studies", path: "/case-studies" },
                { name: "Insights & Blog", path: "/insights" },
                { name: "Careers", path: "/careers" },
                { name: "Services", path: "/services" },
                { name: "Industries", path: "/industries" },
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.path} className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2">
                    <span className="h-1 w-1 bg-gold rounded-full"></span>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-lg mb-6 uppercase tracking-wider text-gold">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-gray-400">
                <MapPin className="h-5 w-5 text-gold shrink-0 mt-1" />
                <span className="text-sm">{CONTACT_INFO.address}</span>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <Phone className="h-5 w-5 text-gold shrink-0" />
                <a href={`tel:${CONTACT_INFO.phone}`} className="text-sm hover:text-white">{CONTACT_INFO.phone}</a>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <Mail className="h-5 w-5 text-gold shrink-0" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="text-sm hover:text-white">{CONTACT_INFO.email}</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs uppercase tracking-wider">
            © {new Date().getFullYear()} Yantraksh Projects. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-500 text-xs uppercase tracking-wider hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-500 text-xs uppercase tracking-wider hover:text-white">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
